import { Pipe, PipeTransform } from '@angular/core';
import { isNumber } from 'lodash';

@Pipe({
  name: 'timeDuration',
  pure: true,
  standalone: false,
})
export class TimeDurationPipe implements PipeTransform {
  transform(value?: number, unit: 'auto' | 'hr' | 'min' | 'sec' = 'auto', decimal: boolean = false): string {
    if (!isNumber(value)) return '';
    const seconds = isNaN(value) ? 0 : value;

    if (unit === 'auto') {
      return this.formatAuto(seconds);
    } else if (decimal) {
      return this.formatDecimal(seconds, unit);
    } else {
      return this.formatFixed(seconds, unit);
    }
  }

  private formatAuto(seconds: number): string {
    const hours = seconds / 3600;
    const minutes = seconds / 60;
    let pre: number, by: number, unit: string;

    if (hours > 1) {
      pre = Math.floor(hours);
      by = Math.round(minutes - pre * 60);
      unit = 'hr';
    } else if (minutes > 1) {
      pre = Math.floor(minutes);
      by = Math.round(seconds - pre * 60);
      unit = 'min';
    } else {
      pre = 0;
      by = Math.round(seconds);
      unit = 'sec';
    }

    return `${pre}:${by < 10 ? '0' : ''}${by} ${unit}`;
  }

  private formatDecimal(seconds: number, unit: 'hr' | 'min' | 'sec'): string {
    let value: number;

    if (unit === 'hr') {
      value = seconds / 3600;
    } else if (unit === 'min') {
      value = seconds / 60;
    } else {
      value = seconds;
    }

    return `${value} ${unit}`;
  }

  private formatFixed(seconds: number, unit: 'hr' | 'min' | 'sec'): string {
    let pre: number = 0;
    let by: number = 0;

    if (unit === 'hr') {
      const hours = seconds / 3600;
      const minutes = seconds / 60;
      pre = Math.floor(hours);
      by = Math.round(minutes - pre * 60);
    } else if (unit === 'min') {
      const totalMinutes = seconds / 60;
      pre = Math.floor(totalMinutes);
      by = Math.round(seconds - pre * 60);
    } else {
      by = Math.round(seconds);
    }

    return unit === 'sec' ? `${by} ${unit}` : `${pre}:${by < 10 ? '0' : ''}${by} ${unit}`;
  }
}
